import script from "./ProgressReport.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgressReport.vue?vue&type=script&setup=true&lang=ts"

import "./ProgressReport.vue?vue&type=style&index=0&id=568fa1d4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-568fa1d4"]])

export default __exports__